import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import { bool } from "prop-types";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { actions as thirdPaymentActions } from "reducers/thirdPayment";
import LotPaymentSummaryBody from "./components/SummaryBody";

const NewLotPaymentSummaryPage = ({ isDesktop }) => {
    const { thirdPaymentData, thirdPartiesTicket } = useSelector((state) => state.thirdPayment);
    const { transactionLines } = useSelector((state) => state.form);
    useConfirmTransaction(thirdPaymentData, thirdPartiesTicket, `lotPayments/newPayment`);
    const willCancel = thirdPaymentData?.cancelTransaction;
    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    return (
        <>
            <Notification scopeToShow="newLotPaymentSummaryPage" />
            <ResponsiveHeader
                id={willCancel ? "payments.cancel.title" : "payments.newLotPayments.title"}
                showLabel={false}
            />
            <MainContainer className="app-content no-column">
                <div className="container" style={{ maxWidth: "58.5rem" }}>
                    <h2>
                        <I18n id="transfer.summary.confirm" />
                    </h2>
                    <LotPaymentSummaryBody
                        accountInfo={thirdPaymentData?.accountInfo}
                        file={thirdPaymentData?.file}
                        typePayment={thirdPaymentData?.typePayment}
                        dateProcess={thirdPaymentData?.dateProcess}
                        processedFileData={thirdPaymentData?.processedFileData}
                        willCancel={thirdPaymentData?.cancelTransaction}
                        status={thirdPaymentData?.idTransactionStatus}
                        isDesktop={isDesktop}
                        showMoreData={showMoreData}
                        setShowMoreData={setShowMoreData}
                    />
                    <GeneralCredentialForm
                        transactionData={thirdPaymentData}
                        action={
                            willCancel ? thirdPaymentActions.cancelTransaction : thirdPaymentActions.validateThirdPay
                        }
                        idActivity="transfers.third.parties"
                        isLoading={transactionLines?.fetching}
                        hideIndications
                    />
                </div>
            </MainContainer>
        </>
    );
};

NewLotPaymentSummaryPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default NewLotPaymentSummaryPage;
